var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){$event.stopPropagation();return _vm.showInfo.apply(null, arguments)}}},[_c('v-icon',[_vm._v("far fa-circle-question")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }